@if (loading) {
  <app-loader></app-loader>
}
<div class="row mb-3">
  <div class="col-12 col-lg-6">
    <app-dynamic-breadcrumb [bgColor]="'transparent'" [fontSize]="'14px'"
    [lastLinkColor]="'rgba(196, 196, 205, 0.42)'" [fontColor]="'#c4c4cd'"></app-dynamic-breadcrumb>
  </div>
  @if (selectedRp) {
    <div class="col-12  text-left text-lg-right">
      <button class="btn btn-primary-ey btn-icon small-font mr-2 hvr-shrink" type="button" (click)="onRefresh()">
        <div class="icon-container"><i class="fas fa-sync-alt"></i></div><span>Refresh</span>
      </button>
      <button class="btn btn-primary-ey btn-icon small-font hvr-shrink" type="button" (click)="prepareReportData(false)">
        <div class="icon-container"><i class="far fa-calendar-check fa-lg"></i></div><span>Prepare
      Data</span>
    </button>
    <button class="btn btn-primary-ey btn-icon small-font hvr-shrink" *appPermission="['S',null,null,'support']"
      type="button" (click)="prepareReportData(true)">
      <div class="icon-container"><i class="far fa-calendar-check fa-lg"></i></div><span>Re-Prepare
    Data</span>
  </button>
</div>
}
</div>
<app-report-pack-filter></app-report-pack-filter>
@if (!selectedRp) {
  <app-no-report-pack></app-no-report-pack>
}
@if (selectedRp) {
  <div class="row mt-3">
    <div class="col-12">
      @if (ingestionsInProgress) {
        <h6 class="text-white-50 font-italic small-font mt-3"><i
        class="fas fa-exclamation-triangle hvr-shrink failed-icon mr-3"></i>There are ingestion(s) in progress for this
      report pack. Please initiate data preparation after ingestion(s) are complete for the selected report pack!</h6>
    }
  </div>
  <div class="col-12">
    <h6 class="text-white-50  font-italic small-font mt-3"><i class="fas fa-info-circle text-yellow mr-3"></i>Please
    note that the source dependencies of the selected reports will included by default (if not already
  prepared/selected) in the final preparation list. </h6>
  @if (hasNewLoad) {
    <h6 class="text-white-50  font-italic small-font mt-3"><i
    class="fas fa-info-circle text-yellow mr-3"></i>The report(s) are not prepared for the latest data load. Please
  prepare data as necessary.</h6>
}
<div class="data-admin-table">
  <p-treeTable #dtadmn [value]="gridReportTreeList" selectionMode="checkbox" class="table-irr"
    [(selection)]="selectedNodes"
    (onNodeSelect)="nodeSelectChange($event)" (onNodeUnselect)="nodeSelectChange($event)" [columns]="headerCols"
    [paginator]="true" [rows]="4" [scrollable]="true" [scrollHeight]="'calc(100vh - 400px)'" sortField="DisplayName"
    sortOrder="1">
    <ng-template pTemplate="paginatorleft">
      <button class="btn btn-clear-filter hvr-shrink" type="button" (click)="dtadmn.reset();clearFilters();">
        <span><i class="fas fa-times mr-1"></i> Clear Filters</span>
      </button>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        @for (col of columns; track col) {
          <th [ttSortableColumn]="col.field">
            @if (col.field === 'DisplayName') {
              <p-treeTableHeaderCheckbox (click)="SelectAllReports($event)"></p-treeTableHeaderCheckbox>
            } @else {
              <ng-template [ngTemplateOutlet]="notNameColumn"></ng-template>
            }
            {{col.header}}
            <p-treeTableSortIcon [field]="col.field"></p-treeTableSortIcon>
          </th>
        }
      </tr>
      <tr>
        @for (col of columns; track col) {
          <th>
            @if (col.field =='LastPreparedDate') {
              <p-datepicker [(ngModel)]="preparedDateFilters" #rdFilter
                selectionMode="range" [showIcon]="true" dateFormat="dd/mm/yy" [readonlyInput]="true"
                placeholder="Select a range" [monthNavigator]="true" [yearNavigator]="true"
                yearRange="{{yearRange}}"
                (ngModelChange)="dtadmn.filter(preparedDateFilters, col.field, 'dateRangeFilter')"
                (onSelect)="closeDateRangeFilter(rdFilter, preparedDateFilters)">
              </p-datepicker>
            }
            @if (col.field !='LastPreparedDate' && col.header!= 'Status') {
              <input type="text" class="w-100" placeholder="Filter Text"
                [value]="dtadmn.filters && dtadmn.filters[col.field] ? dtadmn.filters[col.field].value: ''"
                (input)="dtadmn.filter($event.target.value, col.field, 'contains')">
            }
          </th>
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
      <tr>
        <td
          [title]="rowData.isSourceReport == true ? 'This report cannot be disabled as it has dependencies selected!': ''">
          <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
          <p-treeTableCheckbox [value]="rowNode" ngDefaultControl
            [ngClass]="rowData.isSourceReport == true ? 'disabled-checkbox':''">
          </p-treeTableCheckbox>
          {{rowData.DisplayName}} {{rowData.selectedReportsCount}}
          @if (rowData.PrepLoadId!= 0 && rowData.PrepLoadId < rowData.MaxLoadId) {
            <i
            class="fas fa-info-circle text-yellow small-font float-right"></i>
          }
          @if (rowData.Status === 'In Progress' || rowData.Status === 'Not Started') {
            <i
            class="fas fa-spinner fa-pulse fa-lg float-right"></i>
          }
          @if ((rowData.SourceDependencies && rowData.SourceDependencies.length > 0) || (rowData.Dependents && rowData.Dependents.length > 0)) {
            <button class="btn btn-icon-round hvr-shrink overlay-btn ml-2 float-right"
              (click)="viewDependencies(dependencyListModal, rowData)" type="button" ngbTooltip="View Dependencies"
              container="body" tooltipClass="reporting-tooltip">
              <i class="fab fa-codepen fa-lg dependency-icon float-right"></i>
            </button>
          }
        </td>
        <td>{{rowData.Description}}</td>
        <td>{{rowData.LastPreparedBy}}</td>
        <td>{{rowData.LastPreparedDate | date: 'dd/MM/yyyy'}}</td>
        <td>
          @if (rowData.Status) {
            <div class="status-progress d-flex align-items-center position-relative">
              <div
                class="d-flex align-items-center justify-content-center flex-column mr-5 status-progress-container disabled-view "
                [ngClass]="{'not-applicable':rowData.Status==='Not Applicable'}">
                <div class="circle-status d-flex align-items-center justify-content-center">
                  <i class="fas fa-exclamation fa-lg"></i>
                </div><span>
              Not Applicable</span>
            </div>
            <div
              class="d-flex align-items-center justify-content-center flex-column mr-5 status-progress-container disabled-view "
              [ngClass]="{'completed':rowData.Status==='Success'}">
              <div class="circle-status d-flex align-items-center justify-content-center">
                <i class="fas fa-check fa-lg"></i>
              </div><span>Data
            Preparation Completed</span>
          </div>
          <div
            class="d-flex align-items-center justify-content-center flex-column mr-5 status-progress-container disabled-view"
            [ngClass]="{'failed':rowData.Status==='Failed'}">
            <div class="circle-status d-flex align-items-center justify-content-center">
              <i class="fas fa-times fa-lg"></i>
            </div><span>Data
          Preparation Failed</span>
        </div>
        @if (rowData.ErrorMessage != "" &&  rowData.ErrorMessage != null && rowData.Status==="Failed") {
          <i class="fas fa-exclamation-triangle hvr-shrink failed-icon fa-lg ml-auto" placement="left"
          ngbTooltip={{rowData.ErrorMessage}}></i>
        }
      </div>
    }
  </td>
</tr>
</ng-template>
</p-treeTable>
</div>
</div>
</div>
}

<ng-template #dependencyListModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title d-flex align-items-center m-0 w-100">View Report Dependencies
      <i class="fas fa-times ml-auto cursor-pointer" aria-label="Close" (click)="closeViewDependenciesModal()">
      </i>
    </h5>
  </div>
  <div class="modal-body reports-modal-container">
    <div class="flex flex-column gap-3">
      <div class="dependencies-radio-buttons">
        <p-radioButton name="dependencyDirection" value="ViewSource" inputId="viewDependencySource"
        [(ngModel)]="dependencyDirection"></p-radioButton>
        <label for="viewDependencySource" class="ml-2"> View Reports that {{reportSelectedForDependencyView}}
        depends on</label>
      </div>
      <div class="dependencies-radio-buttons">
        <p-radioButton name="dependencyDirection" value="ViewDependents" inputId="viewDependents"
        [(ngModel)]="dependencyDirection"></p-radioButton>
        <label for="viewDependents" class="ml-2"> View Reports that are dependent on
        {{reportSelectedForDependencyView}}</label>
      </div>
    </div>
    <div class="horizontal-line"></div>
    @if (dependencyDirection == 'ViewSource' && selectedReportSourceDependencies.length == 0) {
      <div>
        <p style="font-style: italic;">{{reportSelectedForDependencyView}} is not dependent on any report.</p>
      </div>
    }
    @if (dependencyDirection == 'ViewSource' && selectedReportSourceDependencies.length > 0) {
      <div>
        <ul>
          @for (d of selectedReportSourceDependencies; track d) {
            <li>{{ d.ParentSuiteName }} - {{d.ParentDisplayName}}</li>
          }
        </ul>
      </div>
    }
    @if (dependencyDirection == 'ViewDependents' && selectedReportDependents.length == 0) {
      <div>
        <p style="font-style: italic;">There are no reports dependent on {{reportSelectedForDependencyView}}.</p>
      </div>
    }
    @if (dependencyDirection == 'ViewDependents' && selectedReportDependents.length > 0) {
      <div>
        <ul>
          @for (d of selectedReportDependents; track d) {
            <li>{{ d.SuiteName }} - {{d.ReportDisplayName}}</li>
          }
        </ul>
      </div>
    }
  </div>
</ng-template>